<nz-modal
  [(nzVisible)]="isShowRegistrationMore"
  nzCentered
  (nzOnCancel)="handleCancel()"
  (nzOnOk)="handleOk()"
  nzWrapClassName="login-modal"
  nzWidth="600px"
  nzMaskClosable="false"
  nzKeyboard="false"
  >
  <ng-container *nzModalContent>
    @if (activeStep === -1) {
      <div class="content-holder">
        <nz-skeleton [nzActive]="true" />
      </div>
    }

    @if (activeStep === 1) {
      <div class="content-holder">
        <h1 class="modal-header">Upload your resume</h1>
        <p>
          Upload your resume and we’ll get started finding your dream career right
          away.
          <b
            >You will need to upload a resume before you start applying for
            roles.</b
            >
          </p>
          <div
            (click)="file.click()"
				style="
					position: relative;
					bottom: -36px;
					z-index: 9;
					height: 50px;
					left: 0px;
					width: auto;
					margin-right: 40px;
					cursor: pointer;
				"
          ></div>
          <mat-form-field class="block-input" style="margin-top: -20px">
            <input
              matInput
              type="text"
              placeholder="Select your resume"
              [value]="fileName"
              [disabled]="true"
              (click)="file.click()"
              />
              <label
                matSuffix
                for="resumeUpload"
                style="margin-right: 15px; cursor: pointer"
                >
                <i class="fa-regular fa-upload"></i>
              </label>
            </mat-form-field>
            @if (errMsgUpload) {
              <span nz-typography nzType="danger">{{ errMsgUpload }}</span>
            }
            <div>Supports: .DOC .DOCX .PDF. Max file size of 5MB</div>
            <input
              style="display: none"
              id="resumeUpload"
              name="resumeUpload"
              type="file"
              [accept]="acceptedFiles"
              (change)="handleInputChange($event)"
              #file
              />
              <br /><br />
              <button
                nz-button
                class="btn-next"
                nzType="primary"
                nzSize="large"
                nzShape="round"
                (click)="nextStep(2)"
                [disabled]="based64 === ''"
                >
                Upload
              </button>
            </div>
          }
          @if (activeStep === 2) {
            <div class="content-holder">
              <h1 class="modal-header">Tell us about yourself</h1>
              <p>
                By providing a little information about your experience and goals, we
                can help your find a career that you will love.
              </p>
              <ng-container [formGroup]="step2Form">
                <div
                  class="nz-block-input"
					[ngClass]="
						step2Form.controls['jobCategoryId'].status === 'INVALID' &&
						step2Form.controls['jobCategoryId'].touched
							? 'error'
							: ''
					"
                  >
                  <label>Preferred industry</label>
                  <nz-select
                    nzShowSearch
                    formControlName="jobCategoryId"
                    nzPlaceHolder="Select option"
                    >
                    @for (option of jobCategories; track option) {
                      <nz-option [nzLabel]="option.option"
                        [nzValue]="option.id"
                       />
                    }
                  </nz-select>
                </div>
                <div
                  class="nz-block-input"
					[ngClass]="
						step2Form.controls['workAvailabilityId'].status === 'INVALID' &&
						step2Form.controls['workAvailabilityId'].touched
							? 'error'
							: ''
					"
                  >
                  <label>Work availability</label>
                  <nz-select
                    nzShowSearch
                    formControlName="workAvailabilityId"
                    nzPlaceHolder="Select option"
                    >
                    @for (option of availability; track option) {
                      <nz-option [nzLabel]="option.option"
                        [nzValue]="option.id"
                       />
                    }
                  </nz-select>
                </div>
                <div
                  class="nz-block-input"
					[ngClass]="
						step2Form.controls['preferredWorkLocationId'].status ===
							'INVALID' && step2Form.controls['preferredWorkLocationId'].touched
							? 'error'
							: ''
					"
                  >
                  <label>Preferred work setup</label>
                  <nz-select
                    nzShowSearch
                    formControlName="preferredWorkLocationId"
                    nzPlaceHolder="Select option"
                    >
                    @for (option of workLocations; track option) {
                      <nz-option [nzLabel]="option.option"
                        [nzValue]="option.id"
                       />
                    }
                  </nz-select>
                </div>
                <div
                  class="nz-block-input"
					[ngClass]="
						step2Form.controls['isRelocationOption'].status === 'INVALID' &&
						step2Form.controls['isRelocationOption'].touched
							? 'error'
							: ''
					"
                  >
                  <label>Is relocation an option?</label>
                  <nz-select
                    nzShowSearch
                    formControlName="isRelocationOption"
                    nzPlaceHolder="Select option"
                    >
                    @for (option of relocationOptions; track option) {
                      <nz-option [nzLabel]="option"
                        [nzValue]="option"
                       />
                    }
                  </nz-select>
                </div>
              </ng-container>
              <br /><br />
              <button
                nz-button
                class="btn-next"
                nzType="primary"
                nzSize="large"
                [disabled]="step2Form.status === 'INVALID'"
                nzShape="round"
                (click)="nextStep(3)"
                >
                Next
              </button>
              <button
                nz-button
                class="btn-next"
                nzType="primary"
                nzSize="large"
                nzShape="round"
                style="margin-left: 10px"
                (click)="skip(2)"
                >
                Skip
              </button>
            </div>
          }
          @if (activeStep === 3) {
            <div class="content-holder">
              <h1 class="modal-header">A few last things</h1>
              <p>We just have a few more questions and then we are done.</p>
              <ng-container [formGroup]="step3Form">
                <div
                  class="nz-block-input"
					[ngClass]="
						step3Form.controls['linkedInUrl'].status === 'INVALID' &&
						step3Form.controls['linkedInUrl'].touched
							? 'error'
							: ''
					"
                  >
                  <label>LinkedIn URL</label>
                  <input
                    nz-input
                    formControlName="linkedInUrl"
                    placeholder="LinkedIn URL"
                    nzSize="large"
                    />
                  </div>
                  <div
                    class="nz-block-input"
					[ngClass]="
						step3Form.controls['sourceId'].status === 'INVALID' &&
						step3Form.controls['sourceId'].touched
							? 'error'
							: ''
					"
                    >
                    <label>{{ siteData.profile.skills.howDidYouHear.header }}</label>
                    <nz-select
                      nzShowSearch
                      formControlName="sourceId"
                      nzPlaceHolder="Select option"
                      >
                      @for (option of sources; track option) {
                        <nz-option [nzLabel]="option.option"
                          [nzValue]="option.id"
                         />
                      }
                    </nz-select>
                  </div>
                  <div
                    class="nz-block-input"
					[ngClass]="
						step3Form.controls['whyWorkAtCloudstaff'].status === 'INVALID' &&
						step3Form.controls['whyWorkAtCloudstaff'].touched
							? 'error'
							: ''
					"
                    >
                    <label>{{ siteData.profile.skills.whyDoYouWant.header }}</label>
                    <input
                      nz-input
                      formControlName="whyWorkAtCloudstaff"
                      placeholder="{{ siteData.profile.skills.whyDoYouWant.placeHolder }}"
                      nzSize="large"
                      (blur)="onBlur('whyWorkAtCloudstaff')"
                      />
                    </div>
                  </ng-container>
                  <br /><br />
                  <button
                    nz-button
                    class="btn-next"
                    nzType="primary"
                    nzSize="large"
                    nzShape="round"
                    [disabled]="step3Form.status === 'INVALID'"
                    nzShape="round"
                    (click)="nextStep(4)"
                    >
                    Next
                  </button>
                  <button
                    nz-button
                    class="btn-next"
                    nzType="primary"
                    nzSize="large"
                    nzShape="round"
                    style="margin-left: 10px"
                    (click)="skip(3)"
                    >
                    Skip
                  </button>
                </div>
              }
            </ng-container>
            <div *nzModalFooter></div>
          </nz-modal>
